import React, { useEffect, useState } from 'react';
import { Button, Modal, Stack, Image } from 'react-bootstrap';
import { IMAGE_PATHS } from 'constants/imagePaths';
import useCommonStore from 'store/common';
import { useGetFollowingCompanyQuery } from 'services';
import InfiniteScroll from 'react-infinite-scroll-component';
import { S3_URL } from 'constants/index';
import { unitNumber } from 'utils';
import Loader from 'components/Common/Loader';
import { useQueryClient } from '@tanstack/react-query';
import useTranslate from 'hooks/useTranslate';
import { useNavigate } from 'react-router-dom';
import { updateIsConnected } from 'store/feeds';

const FollowingList: React.FC<any> = () => {
	const { modalConfig = {} }: any = useCommonStore((state) => state);
	const { id } = modalConfig;
	const [currentPage, setCurrentPage] = useState(1);
	const userData = {
		currentPage,
		limit: 7,
		order: 'DESC',
		id: id,
		keyword: '',
	};
	const navigate = useNavigate();
	const { translate } = useTranslate();
	const queryClient = useQueryClient();

	const [userList, setUsersList] = useState<any>([]);
	const { data: { docs = [], meta = {} } = {} } = useGetFollowingCompanyQuery(userData);

	const loadMoreFunc = () => {
		setCurrentPage((prev) => prev + 1);
	};

	useEffect(() => {
		setUsersList(docs);
	}, [docs]);

	useEffect(() => {
		if (currentPage > 1) {
			queryClient.invalidateQueries({ queryKey: ['following-company'] });
			setUsersList((prev: any) => [...prev, ...docs]);
		}
	}, [currentPage]);
	interface User {
		userId: number;
	}

	const goToProfile = (user: any) => {
		navigate(`/${user?.userType}/profile/${user?.userId}`);
	};

	return (
		<Modal.Body className="p-30 pe-0">
			<Button
				className="close-btn rounded-circle border-0 fw-bold position-absolute"
				onClick={() => {
					setUsersList([]);
					modalConfig?.onClose();
				}}
			>
				<i className="ri-close-line"></i>
			</Button>
			<Stack className="share-post gap-3 gap-sm-4">
				<div className="share-post-head d-flex align-items-center justify-content-between my-2">
					<h4 className="fw-bold mb-0">{translate('Modal.followings')}</h4>
					<h5 className="mb-0">
						{unitNumber(meta?.totalDocs, 0)} {translate('Modal.followings')}
					</h5>
				</div>

				<div id={`infiniteDiv-users-list`} className="users-list">
					<InfiniteScroll
						dataLength={userList?.length}
						next={loadMoreFunc}
						hasMore={meta?.hasNextPage}
						loader={
							userList?.length >= 1 && (
								<div className="d-flex justify-content-center align-items-center">
									<Loader />
								</div>
							)
						}
						scrollableTarget={`infiniteDiv-users-list`}
						scrollThreshold="300px"
						refreshFunction={loadMoreFunc}
						pullDownToRefreshThreshold={50}
						pullDownToRefreshContent={
							<h3 style={{ textAlign: 'center' }}>
								&#8595; {translate('Modal.pullDownToRefresh')}
							</h3>
						}
						releaseToRefreshContent={
							<h3 style={{ textAlign: 'center' }}>&#8593; {translate('Modal.releaseToRefresh')}</h3>
						}
					>
						{userList?.length > 0 ? (
							userList?.map((user: any) => (
								<div key={user?.userId} className="users-detail d-flex align-items-center gap-2">
									<div className="d-flex align-items-center gap-2 gap-xl-3 flex-1">
										<div className="users-detail-profile rounded-circle">
											<Image
												onClick={() => goToProfile(user)}
												style={{ cursor: 'pointer' }}
												src={
													user?.profilePicture
														? `${S3_URL}${user.profilePicture}`
														: IMAGE_PATHS.UserDefault
												}
												className="w-100 h-100 object-fit-cover rounded-circle"
												loading="lazy"
											/>
										</div>
										<div className="users-detail-info flex-1">
											<h6
												onClick={() => goToProfile(user)}
												style={{ cursor: 'pointer' }}
												className="fw-bold mb-1"
											>
												{user?.name}
											</h6>
											<p className="mb-0">
												{[user?.userType === 'company' && user?.address ? `${user.address}` : null]
													.filter(Boolean)
													.join(' ')}
											</p>
										</div>
									</div>
								</div>
							))
						) : (
							<Stack>{translate('Common.noDataFound')}</Stack>
						)}
					</InfiniteScroll>
				</div>
			</Stack>
		</Modal.Body>
	);
};

export default FollowingList;
